import { css } from '@emotion/react';
import { lighten } from '@mui/material';
import { theme } from 'global';

const backgroundColor = (selected, shouldHighlight) => {
  if (selected) {
    return lighten(theme.colors.primary.medium, 0.92);
  }
  if (shouldHighlight) {
    // 1A suffix is 10% opacity
    return `${theme.colors.primary.lightest}1A`;
  }

  return 'inherit';
};

export const orderRow = (selected, shouldHighlight) => css`
  padding: 16px 0;
  background-color: ${backgroundColor(selected, shouldHighlight)};
  cursor: pointer;

  :hover {
    background-color: ${backgroundColor(selected, shouldHighlight)};
  }

  ${shouldHighlight &&
  `> td:first-of-type {
    ::before {
      content: ' ';
      float: left;
      margin-top: 0.35rem;
      margin-left: -20px;
      border-radius: ${theme.radii.lg};
      width: 8px;
      height: 8px;
      background-color: ${theme.colors.primary.lighter};
      
      @media screen and (max-width: 1395px) {
        margin-left: -12px;
      }
    }
  }`}
`;

export const userRow = (selected) => css`
  padding: 8px 24px;
  background-color: ${selected
    ? lighten(theme.colors.primary.medium, 0.92)
    : 'inherit'};

  :hover {
    background-color: ${selected
      ? lighten(theme.colors.primary.medium, 0.92)
      : theme.colors.neutral[0]};
  }
`;

export const statusInfoIcon = css`
  width: 15px;
  height: 15px;
  vertical-align: sub;
`;

export const checkbox = css`
  text-overflow: unset !important;
  width: 88px;
`;

export const toggle = css`
  margin-left: 0;

  span.MuiTypography-root,
  span.MuiTypography-root.Mui-Disabled {
    color: ${theme.colors.neutral[500]};
  }
`;

export const actions = css`
  display: flex;
  align-items: center;

  & > div:not(:first-of-type) {
    margin-left: 16px;
  }

  @media screen and (min-width: ${theme.breaks.md}px) and (max-width: ${theme
      .breaks.summary}px) {
    justify-content: flex-end;

    & > div:not(:first-of-type) {
      margin-left: 4px;
    }
  }
`;

export const tooltip = css`
  margin-left: 4px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const switchCellContent = css`
  display: flex;
  align-items: center;
`;

export const visibleOverflow = css`
  overflow: visible;
`;

export const emailWithCopy = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  max-width: 100%;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const emailText = css`
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const copyIcon = css`
  flex-shrink: 0;
  cursor: pointer;
`;
